export default __webpack_public_path__ + "static/media/vitamins.0527a65a.jpg";